import { render } from "./Images.vue?vue&type=template&id=13d1d6ec"
import script from "./Images.vue?vue&type=script&lang=ts"
export * from "./Images.vue?vue&type=script&lang=ts"
script.render = render

export default script